import CustomerBillingSummaryCSP from "../../models/csp/CustomerBillingSummaryCSP";
import service from "../service";
import baseEndpointPartnerCenter from "./servicePartnerCenter";

export default {
  components: { service: service },
  methods: {
    async getCustomerBillingSummaryCSP(
      id: string
    ): Promise<CustomerBillingSummaryCSP> {
      const res = await service.methods.getEndpointAsync(
        `${baseEndpointPartnerCenter}/customers/${id}/usagesummary`
      );
      return new CustomerBillingSummaryCSP({
        amount: res.budget?.amount ?? null,
        startDate: res.billingStartDate,
        endDate: res.billingEndDate,
        totalCost: res.totalCost,
        customerId: id
      });
    }
  }
};
